import { Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";


/**
 * Compact inline Premium upsell. Deep-links to `/profile#premium-card`
 * where the PremiumCard component handles checkout.
 *
 * Props:
 * - reason: short machine label (e.g. "planner_days", "pantry_limit_reached")
 *   — used to attach to data-testid for QA targeting.
 * - title: optional override of the small headline.
 * - description: optional override of the body copy.
 */
export const UpgradePrompt = ({ reason, title, description }) => {
  const navigate = useNavigate();
  const testidSuffix = reason ? `-${reason}` : "";

  return (
    <section
      className="rounded-[26px] border border-amber-200 bg-amber-50/70 p-4"
      data-testid={`upgrade-prompt${testidSuffix}`}
    >
      <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.28em] text-amber-700">
        <Sparkles className="h-4 w-4" />
        Smartly Premium
      </p>
      <p className="mt-3 text-sm font-semibold text-stone-900" data-testid={`upgrade-prompt-title${testidSuffix}`}>
        {title || "Bekijk Smartly Premium"}
      </p>
      <p className="mt-1 text-sm text-stone-700" data-testid={`upgrade-prompt-body${testidSuffix}`}>
        {description ||
          "Smartly Free ondersteunt basisplanning. Upgrade naar Premium voor volledige weekplanning, onbeperkte pantry en slimmere boodschappen."}
      </p>
      <Button
        className="mt-3 h-11 rounded-full bg-emerald-700 px-5 text-white hover:bg-emerald-800"
        onClick={() => navigate("/profile#premium-card")}
        data-testid={`upgrade-prompt-cta${testidSuffix}`}
      >
        Bekijk Premium
      </Button>
    </section>
  );
};
